import dayjs from 'dayjs';

export type DateRange = { start: string | null; end: string | null };

// Single-calendar range selection: first click sets start, second click sets
// end (or resets start if earlier), and a click when both are set starts over.
export const selectRangeDate = (range: DateRange, clicked: string): DateRange => {
  if (!range.start || (range.start && range.end)) {
    return { start: clicked, end: null };
  }
  if (dayjs(clicked).isBefore(dayjs(range.start))) {
    return { start: clicked, end: null };
  }
  return { start: range.start, end: clicked };
};
